@if (availableTemplates.length > 1) {
  <div class="d-inline-flex align-items-center">
    <label class="title--overline mb-0" for="templateSelector">Template:</label>
    <select id="templateSelector" class="form-select" [formControl]="templateFC">
      @for (t of availableTemplates; track t) {
        <option [ngValue]="t.templateID">
          {{t.templateName}}
        </option>
      }
    </select>
  </div>
}
@if (templateMetaData != null && charData != null) {
  <rl-char-data-table #charDataTable [charData]="charData"
    [template]="templateMetaData" [editMode]="true" (tableCharDataChange)="charData=$event.charData">
  </rl-char-data-table>
}